import 'styles/templates/login.scss';
import 'styles/templates/account.scss';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import Vue from 'vue';
import 'scripts/vue/main';
import 'scripts/utils/smoothscroll';
import localStorage from 'local-storage';
import { px_breakpoints } from 'scripts/utils/breakpoints';
import { Splide, SplideSlide } from '@splidejs/vue-splide';

import TransitionExpand from '../transitions/TransitionExpand';

window.PSTheme.Vue.Account = new Vue({
  name: 'Account',

  delimiters: ['${', '}'],

  components: {
    Slider: Splide,
    Slide: SplideSlide,
    TransitionExpand,
  },
  data() {
    return {
      accountState: '',
      accordionClosed: false,
      showPassword: false,
      activeCTA: 'orders',
      points: 0,
      newAddressOpen: false,
      editAddressID: 0,
      outlet: false,
      userToken: null,
      preorders: null,
      preorder_products: [],
      returnsData: null,
      returnsResponse: null,
      returnsPolicy: null,
      returnsMessage: null,
      returnsValidation: null,
      loading: false,
      carouselOptions: {
        perPage: 4,
        perMove: 1,
        pagination: false,
        gap: '.25rem',
        breakpoints: {
          [px_breakpoints['--desktop-up']]: {
            perPage: 3,
            padding: {
              right: '0',
            },
          },
          [px_breakpoints['--laptop-up']]: {
            perPage: 2,
            padding: {
              right: '0',
            },
          },
          [px_breakpoints['--tablet-up']]: {
            perPage: 1,
            padding: {
              right: '2rem',
            },
          },
        },
      },
    };
  },

  mounted() {
    this.accountState = window.location.pathname;
    this.activeCTA = this.accountState.includes('addresses')
      ? 'addresses'
      : 'orders';

    if (window.location.search.includes('view-preorders')) {
      this.updateAccountState('/account?view-preorders', true);
      this.activeCTA = 'preorders';
      this.getPreorders(this.$refs.customer.id);
    }
    if(document.getElementsByTagName( 'html' )[0].classList.contains('outlet')) this.outlet = true;
  },

  watch: {
    accountState: {
      immediate: true,
      handler() {
        window.scrollTo(0, 500);
        switch (this.activeCTA) {
          case 'orders':
            window.addEventListener('smile-ui-loaded', (event) => {
              console.log('SMILEUI READY!');
            });
            break;
          case 'addresses':
            setTimeout(() => {
              // Initialize listeners on address selectors, callback in shopify_common.js
              new Shopify.CountryProvinceSelector(
                'AddressCountryNew',
                'AddressProvinceNew',
                {
                  hideElement: 'AddressProvinceContainerNew',
                }
              );
              // Initialize each edit form's country/province selector
              document
                .querySelectorAll('.address-country-option')
                .forEach((option) => {
                  const { formId } = option.dataset;
                  const countrySelector = `AddressCountry_${formId}`;
                  const provinceSelector = `AddressProvince_${formId}`;
                  const containerSelector = `AddressProvinceContainer_${formId}`;
                  new Shopify.CountryProvinceSelector(
                    countrySelector,
                    provinceSelector,
                    {
                      hideElement: containerSelector,
                    }
                  );
                });
            }, 3000);
            break;
          case 'returns':
            if (!this.returnsPolicy) {
              let url = '/pages/returns-portal-policy?view=page-content';
              if(this.outlet) url = '/pages/outlet-returns-portal-policy?view=page-content';
              fetch(url)
                .then((res) => res.text())
                .then((html) => {
                  this.returnsPolicy = html;
                });
            }
            break;
        }
      },
    },

    preorders() {
      if (this.preorders.message !== 'success') return;
      this.preorder_products = [];
      this.loading = this.preorders && this.preorders.data.length !== 0;
      if (this.preorders && this.preorders.data.length !== 0) {
        this.preorders.data.forEach((item) => {
          let productData = {};
          try {
            fetch(`/products/${item.handle}.js`)
              .then((res) => {
                if (!res.ok) {
                  throw new Error('Product not found.');
                } else {
                  return res.json();
                }
              })
              .then((data) => {
                productData = {
                  has_shopify_data: true,
                  ...data,
                };
              });
          } catch (err) {
            console.log(err);
          }
          productData.preorder_title = item.title;
          (productData.etd_new = item.ETD_new),
            (productData.etd_old = item.ETD_old),
            (productData.order_token = item.order_token),
            (productData.order_ref = item.order_ref);
          this.preorder_products.push(productData);
        });
      }
      this.loading = false;
    },
  },

  methods: {
    updateAccountState(pathname, async = false) {
      this.loading = true;
      this.accordionClosed =
        this.accountState === pathname && this.accordionClosed === false;
      this.accountState = pathname;
      const url = window.location.origin + this.accountState;
      window.history.replaceState({ path: null }, '', url);
      if (!async) {
        this.loading = false;
      }
    },

    print() {
      window.print();
    },

    getPreorders(customerId) {
      if (!this.preorders) {
        fetch(`/a/ps/${customerId}/preorder`)
          .then((res) => res.json())
          .then((data) => {
            this.preorders = data;
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        this.loading = false;
      }
    },

    sendRequestReturn(e, userId, email) {
      this.loading = true;
      window.scrollTo(0, 500);
      const form = e.target;
      const formData = {
        ref: form.dataset.order_ref,
        email,
        reason: form.querySelector('select[name="reason"]').value,
        items: [],
      };
      form.querySelectorAll('table.line-item').forEach((item) => {
        if (Number(item.querySelector('input[name="quantity"]').value) > 0) {
          formData.items.push({
            name: item.dataset.name,
            qty: Number(item.querySelector('input[name="quantity"]').value),
            comments: item.querySelector('textarea[name="comment"]').value,
            productOptionId: Number(item.dataset.product_option_id),
          });
        }
      });
      if (formData.items.length === 0) {
        this.loading = false;
        this.returnsValidation =
          'Please specify a quantity for the items you are returning.';
      } else {
        const requestOptions = {
          headers: {
            'Content-Type': 'application/json',
            'Custom-Token': this.userToken,
          },
          method: 'POST',
          body: JSON.stringify(formData),
          redirect: 'follow',
        };
        fetch(`/a/ps/${userId}/return/${formData.ref}`, requestOptions)
          .then((res) => res.json())
          .then((data) => {
            this.returnsMessage = data.message;
            this.returnsResponse = data.data;
            this.loading = false;
            this.returnsValidation = null;

            if (data.message == 'success') {
              localStorage(`PSReturn_${formData.ref}`, true);
            }
          })
          .catch((error) => {
            console.log('error', error);
            window.open('https://shineon.partytime.nz/return', '_blank');
            this.returnsData = null;
            this.loading = false;
            this.returnsValidation = null;
            this.updateAccountState('/account');
            this.activeCTA = 'orders';
          });
      }
    },

    getRequestReturn(userId, userToken, orderName) {
      this.userToken = userToken;
      this.returnsData = null;
      this.updateAccountState(
        `/account?return-request=${userId}-${userToken}-${orderName}`,
        true
      );
      this.activeCTA = 'returns';
      fetch(`/a/ps/${userId}/return/${orderName}`, {
        mode: 'same-origin',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'Custom-Token': userToken,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === 'success') {
            this.returnsData = data;
            this.loading = false;
          } else {
            window.open('https://shineon.partytime.nz/return', '_blank');
            this.returnsData = null;
            this.loading = false;
            this.updateAccountState('/account');
            this.activeCTA = 'orders';
          }
        })
        .catch((error) => {
          console.log('error', error);
          window.open('https://shineon.partytime.nz/return', '_blank');
          this.returnsData = null;
          this.loading = false;
          this.updateAccountState('/account');
          this.activeCTA = 'orders';
        });
    },

    returnRequestSent(ref) {
      if (localStorage(`PSReturn_${ref}`)) {
        return true;
      }
    },

    decrementQuantity(e) {
      const qtyInput = e.target.parentNode.querySelector('input');
      if (qtyInput.value == 0) return;
      qtyInput.value = Number(qtyInput.value) - 1;
    },

    incrementQuantity(e) {
      const qtyInput = e.target.parentNode.querySelector('input');
      if (qtyInput.value == qtyInput.max) return;
      qtyInput.value = Number(qtyInput.value) + 1;
    },

    deleteAddress(formID) {
      Shopify.postLink(`/account/addresses/${formID}`, {
        parameters: {
          _method: 'delete',
        },
      });
    },
  },
}).$mount('.account');
